import { render, staticRenderFns } from "./UiBookmarks.vue?vue&type=template&id=5a15efc0"
import script from "./UiBookmarks.vue?vue&type=script&lang=js"
export * from "./UiBookmarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports